<template>
  <drag-dialog
    title="分享"
    :width="500"
    :visible.sync="visible"
    :footerBtn="footerBtn"
    :submit="submit"
    :cancel="cancel">
    <div
      v-if="step === 1"
      class="form-box">
      <div class="common-radio-box radio-primary">
        <el-radio
          v-model="shareType"
          :label="0"
          >生成链接</el-radio
        >
        <el-radio
          v-model="shareType"
          :label="1"
          >分享给系统用户</el-radio
        >
      </div>
      <div class="form-item-box">
        <span class="label-box dialog-label"
          >已选{{ resourceType === 'dataSet' ? '文件' : '场景' }}：</span
        >
        <el-tooltip
          placement="right"
          :effect="$theme.tooltipKey()">
          <div
            slot="content"
            class="resource-list-box">
            <div
              v-for="(item, index) in resourceList"
              :key="index"
              class="list-item">
              <span class="text-label">
                {{
                  resourceType === 'dataSet' ? item.nodeName : item.sceneName
                }}
              </span>
            </div>
          </div>
          <div class="dataset-list-box">
            <div
              v-show="getDataSetsName()"
              class="resource-name-box already-file dialog-label text-overflow">
              {{ getDataSetsName() }}
            </div>
            <div v-if="resourceList.length > 3">
              <span class="dialog-label">
                等{{ resourceList.length }}个{{
                  resourceType === 'dataSet' ? '文件' : '场景'
                }}
              </span>
            </div>
          </div>
        </el-tooltip>
      </div>
      <div class="form-item-box">
        <span class="label-box dialog-label">有效期：</span>
        <div class="common-select-box">
          <el-select
            class="primary-select"
            v-model="limitedTime"
            popper-class="primary-select-outer"
            :popper-append-to-body="true"
            size="small">
            <el-option
              v-for="item in limitedTimeList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
      </div>
      <div v-if="shareType === 1">
        <div class="form-item-box">
          <span class="label-box dialog-label">选择用户：</span>
          <div class="common-select-box">
            <el-input
              size="small"
              class="input-primary"
              placeholder="请输入用户名或手机号"
              v-model="filter"
              @keyup.enter.native="searchUser">
              <i
                slot="suffix"
                class="el-input__icon el-icon-search"
                @click="searchUser"></i>
            </el-input>
          </div>
        </div>
        <div class="user-list-box">
          <div
            v-for="(item, index) in userList"
            :key="index"
            class="user-item-box">
            <span>{{ item.surName }}</span>
            <i
              class="el-icon-error icon"
              @click="removeUser(item)"></i>
            <!-- <div class="remove-btn"></div> -->
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="step === 2"
      class="share-result-box">
      <!-- <div class="resource-box">
        <div class="label-box dialog-label">
          已选{{ resourceType === "dataSet" ? "文件" : "场景" }}：
        </div>
        <el-tooltip placement="right" popper-class="common-tootip-box">
          <div slot="content" class="resource-list-box">
            <div
              v-for="(item, index) in resourceList"
              :key="index"
              class="list-item"
            >
            <span class="text-label">
              {{ resourceType === "dataSet" ? item.nodeName : item.sceneName }}
            </span>
            </div>
          </div>
          <div class="dataset-list-box">
            <div class="resource-name-box dialog-label text-overflow">
              {{ getDataSetsName() }}
            </div>
            <div v-if="resourceList.length > 3">
              <span class="dialog-label">
              等{{ resourceList.length }}个{{
                resourceType === "dataSet" ? "文件" : "场景"
              }}
              </span>
            </div>
          </div>
        </el-tooltip>
      </div> -->
      <div class="share-link-box">
        <div v-if="shareLinkList.length === 1">
          <div class="expiration-data-box">
            <span class="label-box dialog-label">链接有效期：</span>
            <span class="dialog-label">{{
              getExpirationDate(limitedTime)
            }}</span>
          </div>
          <div class="link-url-box">
            <span class="label-box dialog-label">链接地址：</span>
            <span
              class="text-overflow dialog-label"
              :title="shareLinkList[0].link">
              {{ shareLinkList[0].link }}
            </span>
          </div>
          <div class="qrcode-box">
            <span class="label-box dialog-label">二维码：</span>
            <img
              id="qrcode"
              class="qrcode-content-box" />
          </div>
        </div>
        <div
          class="link-list-box"
          v-if="shareLinkList.length > 1">
          <div
            class="link-list-box-item"
            v-for="(item, index) in shareLinkList"
            :key="index">
            <div class="dialog-label">
              <div class="expirationLabel">
                <span class="gr4"> {{ index + 1 }}. </span>
                {{ item.name }}
              </div>
              <div class="expiration-data-box">
                <span class="expirationTime"
                  >链接有效期：{{ getExpirationDate(limitedTime) }}</span
                >
              </div>
            </div>
            <div class="link-content dialog-label text-overflow">
              <img
                id="qrcode"
                :src="item.url"
                class="qrcode-content-box" />
            </div>
            <div>
              <el-button
                class="copy primary-ang-btn primary-btn"
                size="small"
                plain
                data-clipboard-action="copy"
                :data-clipboard-text="getItemText(item.link)"
                @click="copyShareLink"
                >复制链接</el-button
              >
            </div>
          </div>
        </div>
      </div>
      <div class="split-line"></div>
      <div class="copy-btn-box">
        <el-button
          class="copy primary-ang-btn primary-btn"
          size="small"
          plain
          data-clipboard-action="copy"
          :data-clipboard-text="getCopyText(shareLinkList)"
          @click="copyShareLink">
          {{ shareLinkList.length > 1 ? '复制全部链接' : '复制链接' }}
        </el-button>
      </div>
    </div>
  </drag-dialog>
</template>

<script>
import QRCode from 'qrcode'
import Clipboard from 'clipboard'
import dragDialog from '@/components/CustomDragDialog.vue'

import {
  createSceneShare,
  createBimShare,
  createRsShare,
  createWmtsShare,
  createOsgbShare,
  createPanoramaShare,
  createPointCloudShare,
  createCadShare,
  createVectorShare,
  findUserService
} from '@/service/interface'

export default {
  data() {
    return {
      step: 1,
      footerBtn: ['cancel', 'submit'],
      shareType: 0,
      limitedTime: 0,
      limitedTimeList: [
        { value: 0, label: '1天' },
        { value: 1, label: '7天' },
        { value: 2, label: '15天' },
        // { value: 4, label: '永久有效' }
      ],

      filter: '',
      userList: [],

      shareLinkList: []
    }
  },
  props: {
    visible: Boolean,
    resourceType: String,
    resourceList: Array,
    closeDialog: Function
  },
  components: {
    dragDialog
  },
  methods: {
    searchUser() {
      if (!this.filter) {
        this.$message.warning('请输入用户名或手机号')
        return
      }
      let params = {
        searchType: 'phone',
        filter: this.filter
      }
      findUserService(params).then(response => {
        if (response.status === 200) {
          let phoneResult = response.data
          let phoneData = phoneResult.data
          if (phoneData) {
            this.handleSearchResult(phoneData)
          } else {
            params.searchType = 'surname'
            findUserService(params).then(res => {
              if (res.status === 200) {
                let surnameResult = res.data
                if (surnameResult.isSuccess) {
                  let surnameData = surnameResult.data
                  this.handleSearchResult(surnameData)
                } else {
                  this.$message.error('用户不存在，请重新输入！！！')
                  this.filter = ''
                }
              }
            })
          }
        }
      })
    },
    handleSearchResult(data) {
      let find = this.userList.find(el => el.id === data.userId)
      if (!find) {
        let userInfo = {
          id: data.userId,
          surName: data.surName
        }
        this.userList.push(userInfo)
      } else {
        this.$message.error('已选择该用户，请重新输入！！！')
        this.filter = ''
      }
    },
    removeUser(userInfo) {
      let findIndex = this.userList.findIndex(el => el.id === userInfo.id)
      this.userList.splice(findIndex, 1)
      this.filter = ''
    },
    submit() {
      if (this.resourceType === 'dataSet') {
        this.handleDataSetShare()
      } else {
        this.handleSceneShare()
      }
    },
    cancel() {
      this.step = 1
      this.footerBtn = ['cancel', 'submit']
      this.shareType = 0
      this.limitedTime = 0
      this.filter = ''
      this.userList = []
      this.shareLinkList = []
      this.closeDialog()
    },
    handleDataSetShare() {
      let params = this.getShareParams()
      if (this.shareType === 0 && this.step === 1) {
        this.createDataSetShare(params).then(response => {
          if (response.isSuccess) {
            this.$message.success('分享成功！！！')
            this.footerBtn = []
            this.step = 2

            let data = response.data

            let dataType = this.$route.query.dataType
            this.shareLinkList = data.shareItems.map(item => {
              let link = `${window.location.origin}${window.location.pathname}#/dataSetShare/view/${item.shareId}/${item.resourceId}?dataType=${dataType}&token=${item.tokenId}`
              let obj = {
                name: item.resourceName,
                link
              }
              return obj
            })

            this.$nextTick(() => {
              this.initClipboard()
              if (this.shareLinkList.length === 1) {
                this.createQRCode()
              } else {
                this.createMutilpleQRCode()
              }
            })
          } else {
            this.$message.error(response.errMsg)
          }
        })
      } else {
        this.createDataSetShare(params).then(response => {
          if (response.isSuccess) {
            this.$message.success('分享成功')
            this.cancel()
          } else {
            this.$message.error(response.errMsg)
          }
        })
      }
    },
    handleSceneShare() {
      let params = this.getShareParams()
      if (this.shareType === 0 && this.step === 1) {
        createSceneShare(params).then(response => {
          if (response.isSuccess) {
            this.$message.success('分享成功！！！')
            this.footerBtn = []
            this.step = 2

            let data = response.data

            this.shareLinkList = data.shareItems.map(item => {
              let link = `${window.location.origin}${window.location.pathname}#/sceneShare/view/${item.shareId}/${item.resourceId}?viewMode=${item.displayMode}&token=${item.tokenId}`
              let obj = {
                name: item.resourceName,
                link
              }
              return obj
            })

            this.$nextTick(() => {
              this.initClipboard()
              if (this.shareLinkList.length === 1) {
                this.createQRCode()
              } else {
                this.createMutilpleQRCode()
              }
            })
          } else {
            this.$message.error(response.errMsg)
          }
        })
      } else {
        createSceneShare(params).then(response => {
          if (response.isSuccess) {
            this.$message.success('分享成功')
            this.cancel()
          } else {
            this.$message.error(response.errMsg)
          }
        })
      }
    },
    createDataSetShare(params) {
      return new Promise(resolve => {
        let resourceSubType = params.resourceSubType
        if (resourceSubType === 1 || resourceSubType === 2) {
          createBimShare(params).then(response => resolve(response))
        }
        if (resourceSubType === 3) {
          createRsShare(params).then(response => resolve(response))
        }
        if (resourceSubType === 4) {
          createWmtsShare(params).then(response => resolve(response))
        }
        if (resourceSubType === 5) {
          createOsgbShare(params).then(response => resolve(response))
        }
        if (resourceSubType === 6) {
          createPanoramaShare(params).then(response => resolve(response))
        }
        if (resourceSubType === 7) {
          createPointCloudShare(params).then(response => resolve(response))
        }
        if (resourceSubType === 8) {
          createCadShare(params).then(response => resolve(response))
        }
        if (resourceSubType === 9) {
          createVectorShare(params).then(response => resolve(response))
        }
      })
    },
    createQRCode() {
      let linkUrl = this.shareLinkList[0].link
      QRCode.toDataURL(linkUrl, (error, url) => {
        if (!error) {
          document.getElementById('qrcode').src = url
        }
      })
    },
    createMutilpleQRCode() {
      this.shareLinkList = this.shareLinkList.map(item => {
        QRCode.toDataURL(item.link, (error, url) => {
          if (!error) {
            item['url'] = url
          }
        })
        return item
      })
      // let linkUrl = this.shareLinkList[0].link
      // QRCode.toDataURL(linkUrl, (error, url) => {
      //   if (!error) {
      //     document.getElementById('qrcode').src = url
      //   }
      // })
    },
    initClipboard() {
      let copybtn = document.getElementsByClassName('copy')
      this.clipboard = new Clipboard(copybtn)
    },
    getItemText(link) {
      return link
    },
    getCopyText(shareLinkList) {
      let copyText = ''
      if (shareLinkList.length > 1) {
        shareLinkList.forEach((item, index) => {
          let str = `${index + 1}.${item.name}\n${item.link}\n`
          copyText += str
        })
      } else {
        copyText = shareLinkList[0].link
      }
      return copyText
    },
    copyShareLink() {
      this.clipboard.on('success', () => {
        this.$message.success('复制成功！')
      })

      this.clipboard.on('error', () => {
        this.$message.error('复制失败，请手动复制！')
      })
    },
    getShareParams() {
      let shareItems = []
      let shareToUsers = []
      let isCreateLink = false
      let params = {}
      let projId = this.$route.params.projId
      shareItems = this.resourceList.map(item => {
        let obj = { projId }
        if (this.resourceType === 'dataSet') {
          obj.resourceId = item.nodeId
          obj.resourceName = item.nodeName
        } else {
          obj.resourceId = item.sceneId
          obj.resourceName = item.sceneName
        }
        return obj
      })
      if (this.shareType === 1) {
        shareToUsers = this.userList.map(item => {
          let obj = {
            userId: item.id,
            userName: item.surName
          }
          return obj
        })
        isCreateLink = false
      } else {
        isCreateLink = true
      }
      params = {
        shareItems,
        shareToUsers,
        resourceType: 0,
        limitedTime: this.limitedTime,
        isCreateLink: isCreateLink
      }
      if (this.resourceType === 'dataSet') {
        let resourceSubType = this.getResourceSubType()
        params.resourceType = 1
        params.resourceSubType = resourceSubType
      }
      return params
    },
    getResourceSubType() {
      const dataTypeMap = {
        Rs: 3,
        Wmts: 4,
        Osgb: 5,
        Panorama: 6,
        PointCloud: 7,
        Cad: 8,
        Vector: 9
      }

      let resourceSubType = 1
      let dataSet = this.resourceList[0]
      let formatType = dataSet.formatType
      let dataType = this.$route.query.dataType
      if (dataType === 'Bim') {
        resourceSubType = formatType
      } else {
        resourceSubType = dataTypeMap[dataType]
      }
      return resourceSubType
    },
    getDataSetsName() {
      let nameStr = ''
      let nameList = []
      if (this.resourceType === 'dataSet') {
        nameList = this.resourceList.map(el => el.nodeName)
      } else {
        nameList = this.resourceList.map(el => el.sceneName)
      }
      // 超过两个文件只展示前三个
      if (nameList.length > 3) {
        nameStr = `${nameList[0]}、${nameList[1]}、${nameList[1]}`
      } else {
        nameStr = nameList.join('、')
      }
      return nameStr
    },
    getExpirationDate(limitedTime) {
      let find = this.limitedTimeList.find(el => el.value === limitedTime)
      return find.label
    }
  }
}
</script>

<style lang="less" scoped>
.form-box {
  padding: 0px 20px;

  .common-radio-box {
    display: flex;
    justify-content: flex-start;
  }

  .form-item-box {
    display: flex;
    margin: 16px 0px;
    color: var(--default-color);

    .label-box {
      width: 80px;
      text-align: right;
      display: flex;
      justify-content: flex-end;
      align-items: center;
    }

    .dataset-list-box {
      display: flex;
      align-items: center;

      .resource-name-box {
        max-width: 260px;
      }
    }

    .common-select-box {
      flex-grow: 1;

      .el-select {
        width: 100%;
      }
    }
  }

  .user-list-box {
    color: var(--base-bg-light-color55);
    max-height: 100px;
    overflow-y: auto;
    padding-left: 80px;
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    .user-item-box {
      border: 1px solid var(--base-bg-light-color55);
      padding: 0 4px;
      border-radius: 4px;
      font-size: 12px;
      font-weight: 400;
      background-color: var(--base-bg-light-color56);
      display: flex;
      align-items: center;
      justify-content: flex-start;

      > span {
        margin-bottom: 2px;
      }

      .icon {
        margin-left: 5px;
        color: var(--base-bg-light-color57);
        cursor: pointer;
      }
    }
  }
}

.already-file {
  margin: 0px 8px;
  background-color: var(--dialog-file-bgColor);
  padding: 2px 4px;
  border-radius: 4px;
}
.share-result-box {
  margin-top: -10px;
  margin-left: 5px;
  color: var(--default-color);

  .resource-box {
    display: flex;
    margin: 10px 0px;

    .label-box {
      width: 100px;
      text-align: right;
    }

    .dataset-list-box {
      display: flex;

      .resource-name-box {
        max-width: 260px;
        margin: 0px 8px;
        background-color: var(--dialog-file-bgColor);
        padding: 2px 4px;
        border-radius: 4px;
      }
    }
  }

  .share-link-box {
    .label-box {
      width: 100px;
      text-align: right;
      flex-shrink: 0;
    }

    .expiration-data-box {
      display: flex;
      align-items: center;
    }

    .link-url-box {
      margin-top: 16px;
      display: flex;
      align-items: center;
    }

    .qrcode-box {
      display: flex;
      align-items: flex-start;
      margin-top: 16px;
    }

    .qrcode-content-box {
      width: 120px;
      height: 120px;
      border-radius: 4px;
      border: 1px solid var(--base-border-dark-color14);
    }

    .link-content {
      line-height: 36px;
      user-select: text;
      text-align: left;
    }

    .link-list-box {
      min-height: 180px;
      max-height: 410px;
      overflow-y: auto;

      &-item:not(:last-child) {
        margin-bottom: 8px;
      }

      .dialog-label {
        display: flex;
        align-items: center;
        margin-bottom: 8px;
        .expirationLabel {
          font-size: 12px;
          font-weight: 400;
          color: var(--share-dialog-label-color);
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .expirationTime {
          font-size: 12px;
          font-weight: 400;
          color: var(--share-dialog-expiration-text-color);
          background-color: var(--share-dialog-expiration-bgColor);
          border-radius: 4px;
          padding: 1px 6px;
          margin-left: 8px;
          white-space: nowrap;
          word-wrap: normal;
        }
      }
    }
  }

  .copy-btn-box {
    text-align: right;
  }
}

.split-line {
  width: calc(100% + 35px);
  margin: 10px 0px 10px -20px;
  height: 1px;
  background: var(--dialog-footer-border-color);
}

.common-tootip-box {
  .resource-list-box {
    max-height: 300px;
    overflow-y: auto;
    .list-item {
      margin: 5px 0px;

      .text-label {
        color: var(--aside-bg-color);
      }
    }
  }
}
</style>
